import { useCallback } from 'react';

import {
  type IntegrationConnection,
  getIntegrationConnections
} from '../../common/utils/integrations-client/jira/connections';
import useAPI, { type State } from '../../common/hooks/useAPI';
import { useEnterprises } from '../../common/contexts/enterprises';
import {
  INTEGRATION_PRODUCT_SLUGS,
  ProductSlugs,
  type SupportedIntegrationProductSlugs
} from '../../common/constants';

const useIntegrationConnections = (
  enterpriseId?: string,
  token?: string,
  skipRequest = false
): State<IntegrationConnection[]> => {
  const { activeEnterprise } = useEnterprises();
  const hasIntegrationSubscription = activeEnterprise?.subscriptions.some(
    subscription =>
      (INTEGRATION_PRODUCT_SLUGS.includes(
        subscription.product_slug as SupportedIntegrationProductSlugs
      ) ||
        ProductSlugs.axeAuditorIntegration === subscription.product_slug) &&
      subscription.purchase_state === 'paid'
  );

  const dataLoader = useCallback(() => {
    if (!enterpriseId) {
      return Promise.resolve([]);
    }

    if (!token) {
      return Promise.resolve([]);
    }

    if (!hasIntegrationSubscription) {
      return Promise.resolve([]);
    }

    return getIntegrationConnections({
      enterpriseId,
      token
    });
  }, [enterpriseId, token, hasIntegrationSubscription]);

  const { loading, error, data } = useAPI(dataLoader, skipRequest);

  return { loading, error, data };
};

export default useIntegrationConnections;
